var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApartmentLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5498 8.77777C2.5498 8.3652 2.71369 7.96952 3.0054 7.67779C3.29711 7.38606 3.69276 7.22217 4.10531 7.22217H11.8828C12.2954 7.22217 12.691 7.38606 12.9827 7.67779C13.2744 7.96952 13.4383 8.3652 13.4383 8.77777V13.4446C13.4383 13.8571 13.2744 14.2528 12.9827 14.5445C12.691 14.8363 12.2954 15.0002 11.8828 15.0002H4.10531C3.69276 15.0002 3.29711 14.8363 3.0054 14.5445C2.71369 14.2528 2.5498 13.8571 2.5498 13.4446V8.77777Z",
    stroke: "#5E5E60",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2168 11.1113C7.2168 11.3176 7.29874 11.5154 7.4446 11.6613C7.59047 11.8071 7.7883 11.8891 7.99458 11.8891C8.20086 11.8891 8.39869 11.8071 8.54456 11.6613C8.69042 11.5154 8.77236 11.3176 8.77236 11.1113C8.77236 10.905 8.69042 10.7072 8.54456 10.5613C8.39869 10.4154 8.20086 10.3335 7.99458 10.3335C7.7883 10.3335 7.59047 10.4154 7.4446 10.5613C7.29874 10.7072 7.2168 10.905 7.2168 11.1113Z",
    stroke: "#5E5E60",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88281 7.2224V4.1112C4.88281 3.28606 5.21058 2.49471 5.79401 1.91125C6.37743 1.32779 7.16873 1 7.99382 1C8.81891 1 9.61021 1.32779 10.1936 1.91125C10.7771 2.49471 11.1048 3.28606 11.1048 4.1112V7.2224",
    stroke: "#5E5E60",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16.0003,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApartmentLock);
export default __webpack_public_path__ + "static/media/icon_apartment_lock.aeb94dd73345e48105dd98bc4245b939.svg";
export { ForwardRef as ReactComponent };